import type { Mesh, MeshStandardMaterial, SphereGeometry } from 'three'
import type { MarkerModel } from 'Common/components/elements/visualizer/marker'
import { WaypointMarkerModel } from '@/common/components/elements/visualizer/waypointMarker';


interface VisualizerSceneOptions {
    onLoadedCallback,
    mouseInCallback,
    mouseOutCallback,
    clickedCallback,
    sceneOptions
}

enum CommonCameraPositions {
    front = "front",
    left = "left",
    back = "back",
    right = "right"
}

enum MarkerEventType {
    click = "click",
    mouseover = "mouseover",
    mouseout = "mouseout"
}

type SphereGeometryEvent = Event & {
    type: "mouseover";
} & {
    target: Mesh<SphereGeometry, MeshStandardMaterial>;
}

type MarkerMeshType = Mesh<SphereGeometry, MeshStandardMaterial>

interface MarkerEventCallback {
    (type: MarkerEventType, markerModel: MarkerModel): void
}

interface WaypointEventCallback {
    (type: MarkerEventType, markerModel: WaypointMarkerModel): void
}

export type { VisualizerSceneOptions, SphereGeometryEvent, MarkerEventCallback, MarkerMeshType, WaypointEventCallback }
export { CommonCameraPositions, MarkerEventType }